import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../components/Button';
import { BillingSubscription } from '../SplashPage';
import Popup from 'reactjs-popup';
import styles from '../../../../components/modals/modals.module.scss';
import { ReactComponent as CloseIcon } from '../../../../assets/images/icons/close.svg';
import classNames from 'classnames';
import { supplementsManagement as events } from '../../../../lib/analytics/events';
import { AddressFields } from './UpdateShippingAddressModal';

interface IConfirmAddressChangeModalProps {
  onUpdateThisSubscription: (shippingAddress: AddressFields) => void;
  onUpdateAllSubscriptions: (shippingAddress: AddressFields) => void;
  setConfirmAddressChangeModalOpen: (open: boolean) => void;
  setButtonDisabled: (open: boolean) => void;
  shippingAddress: AddressFields;
  subscription: BillingSubscription;
  trigger: React.ReactElement;
  open: boolean;
}

export default function ConfirmAddressChangeModal({
  onUpdateThisSubscription,
  onUpdateAllSubscriptions,
  setConfirmAddressChangeModalOpen,
  setButtonDisabled,
  shippingAddress,
  trigger,
  subscription,
  open,
}: IConfirmAddressChangeModalProps) {
  const { t } = useTranslation();
  events.shipmentFrequencyTapped({ subscriptionId: subscription.id });
  return (
    <Popup
      className="s3-popup"
      trigger={trigger}
      modal
      closeOnDocumentClick={false}
      open={!!open}
      onOpen={() => {
        setConfirmAddressChangeModalOpen(true);
        events.updateShipmentAddress({ subscriptionId: subscription.id });
      }}
    >
      {(close: () => void) => (
        <div className={styles.container}>
          <div className={classNames(styles.body, styles.shrink)}>
            <div className={styles.header}>
              <h3>{t('update_all_addresses')}</h3>
              <CloseIcon onClick={close} />
            </div>
            <p>
              {t(
                'would_you_like_to_make_these_address_updates_for_all_of_your_supplement_subscriptions_or_just_this_one',
              )}
            </p>
          </div>

          <div className={classNames(styles.actions, styles.shrink)}>
            <Button
              className={styles.button}
              onClick={() => {
                setButtonDisabled(true);
                onUpdateAllSubscriptions(shippingAddress);
              }}
            >
              {t('all_subscriptions')}
            </Button>
            <Button
              tertiary
              className={classNames(styles.button, styles.tertiaryButton)}
              onClick={() => {
                setButtonDisabled(true);
                onUpdateThisSubscription(shippingAddress);
              }}
            >
              {t('just_this_subscription')}
            </Button>
          </div>
        </div>
      )}
    </Popup>
  );
}
